import { render, staticRenderFns } from "./AtlasSystem.vue?vue&type=template&id=4b9311bc&scoped=true"
import script from "./AtlasSystem.vue?vue&type=script&lang=js"
export * from "./AtlasSystem.vue?vue&type=script&lang=js"
import style0 from "./AtlasSystem.vue?vue&type=style&index=0&id=4b9311bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9311bc",
  null
  
)

export default component.exports